/* 
 	* 指令下发组件 
 	* 描述：自定义指令
 	* 创建时间：2017-08-17 
 	* 创建人：shujuan sun 
*/
<template>
    <div>
     	<form class="form-horizontal pt10px">
     		<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>输入指令</label>
				<div class="col-sm-8">
					<textarea type="text" class="form-control" v-model="parameters"></textarea> 
			   </div>	 
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
			 <div class="form-group text-right pt10px" >
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		   </div>
		</form>	
    </div>	
</template>
<script>
	export default {
		name: "InsCustomized",
		data() {
			return {
				parameters :"",    //指令参数
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.parameters = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){ 
				if(this.parameters==''){
					this.alertMsg='请输入指令';
					return;
				}else{
					if(this.parameters.length > 200){
						this.alertMsg='请输入的指令过长';
						return;
					}else{
						this.alertMsg='';
					} 
				}
				let arr = ['CUSTOM',this.parameters]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// InsCustomized.vue?0cd1d564